import roles from "./roles";

const getUserRole = (role) => roles[role]?.role;

export default getUserRole;
